export default `
  mutation generateApiKey {
    generateApiKey {
      apiKey
    }
  }
`
